module.exports =
{
  report: require('./DriversReport/report'),
}